import React from 'react';
import Section from '../Section';
// import style from './SwooptyBg.module.scss';

// interface SwooptyBgProps{
//   color?: string;
// }

const SwooptyBg: React.FC = () => (
  <Section
    className="swoopty-bg swoopty-bg--fixed"
    color="light-pink"
  />
);

export default SwooptyBg;
